<template>
  <div>
    Notifikace
    <!--     {{ A }}
    {{ B }} -->
    <!--     <v-btn @click="performBackgroundFetch">Perform Background Call</v-btn>
    <v-btn @click="scheduleNotification">Schedule Local Notification</v-btn> -->

    <!--<v-btn @click="myBackground">XXX</v-btn> -->

    <!--     <v-btn @click="load">Load</v-btn>
    <v-btn @click="save">Save</v-btn> -->

    <v-btn @click="test">TEST1</v-btn>

    <v-text-field v-model="nickname"></v-text-field>
    <v-btn @click="sendNicknameNotification">Simulace notifikace - Poslat přezdívku</v-btn>
  </div>
</template>

<script>
/* import { BackgroundRunner } from "@capacitor/background-runner";

import { Preferences } from "@capacitor/preferences"; */

/* import { LocalNotifications } from "@capacitor/local-notifications";
import { BackgroundRunner } from "@capacitor/background-runner"; */

/* import { Capacitor, Plugins } from '@capacitor/core';
    const { App, BackgroundRunner } = Plugins;

    const execBackgroundRunner = () => {
        BackgroundRunner.dispatchEvent({
            label: 'myCustomEventWithReturnData',
            event: 'myCustomEventWithReturnData',
            details: {
                // custom data
                alerts,
            },
        });
    }

    if (Capacitor.isNativePlatform()) {
        // runner.js background service on app start and send the data you need
        execBackgroundRunner();

        // BONUS: when you resume your app, force runner.js event again if needed
        App.addListener('resume', () => {
            execBackgroundRunner();
        });
    } */

import { BackgroundRunner } from "@capacitor/background-runner";

export default {
  name: "Notifications",
  props: {},
  components: {},
  data() {
    return {
      nickname: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {},

  computed: {},
  methods: {
    async init() {
      try {
        const permissions = await BackgroundRunner.requestPermissions({
          apis: ["notifications", "geolocation"],
        });
        console.log("init permissions", permissions);
      } catch (err) {
        console.log(`ERROR: ${err}`);
      }
    },
    async test() {
      try {
        const response = await BackgroundRunner.dispatchEvent({
          label: "test",
          event: "fetchTest",
          details: {},
        });
        console.log(`success: ${JSON.stringify(response)}`);
      } catch (err) {
        console.log(`ERROR: ${err}`);
      }
    },
    async sendNicknameNotification() {
      BackgroundRunner.dispatchEvent({
        label: "myCustomEventWithReturnData",
        event: "myCustomEventWithReturnData",
        details: {
          user: {
            nickname: this.nickname,
          },
        },
      });
    },

    /*     async init() {
      try {
        const permissions = await BackgroundRunner.requestPermissions({
          apis: ["notifications", "geolocation"],
        });
        console.log("init permissions", permissions);
      } catch (err) {
        console.log(`ERROR: ${err}`);
      }
    }, */
    /*     async initNotifications() {
      try {
        const permissions = await LocalNotifications.requestPermissions();
        console.log("initNotifications permissions", permissions);
      } catch (err) {
        console.log(`ERROR: ${err}`);
      }
    }, */
    /*     async scheduleNotification() {
    try {
      const result = await BackgroundRunner.dispatchEvent({
        label: "cz.energycloud.home.check",
        event: "notificationTest",
        details: {},
      });
      console.log("Notification scheduled:", result);
    } catch (err) {
      console.error("Notification error:", err);
    }
  }, */
    /*     async myBackground() {
      const data = await BackgroundRunner.dispatchEvent({
        label: "cz.energycloud.home.check",
        event: "myCustomEvent",
        details: {},
      });
      console.log("myBackground()", data);
    }, */
    /*     async myBackground() {
      try {
         await BackgroundRunner.dispatchEvent({
          label: "cz.energycloud.home.check",
          event: "myCustomEvent",
          details: {},
        });
        console.log("myBackground()");
      } catch (error) {
        console.error("myBackground error:", error);
      }
    }, */
    /*     async load() {
      try {
        const data = await BackgroundRunner.dispatchEvent({
          label: "cz.energycloud.home.check",
          event: "load",
          details: {},
        });
        console.log("load()", data);
      } catch (error) {
        console.error("load error:", error);
      }
    },

    async save() {
      try {
        const data = await BackgroundRunner.dispatchEvent({
          label: "cz.energycloud.home.check",
          event: "save",
          details: {},
        });
        console.log("save()", data);
      } catch (error) {
        console.error("save error:", error);
      }
    }, */
    // Test the background fetch
    /*     async performBackgroundFetch() {
      try {
        const result = await BackgroundRunner.dispatchEvent({
          label: "cz.energycloud.home.check",
          event: "fetchTest",
          details: {},
        });
        console.log("Fetch result:", result);
        this.A = result;
      } catch (err) {
        console.error("Fetch error:", err);
      }
    }, */
    // Schedule a notification from background
    /*     async scheduleNotification() {
      try {
        const result = await BackgroundRunner.dispatchEvent({
          label: "cz.energycloud.home.check",
          event: "notificationTest",
          details: {},
        });
        this.B = result;
        console.log("Notification scheduled:", result);
      } catch (err) {
        console.error("Notification error:", err);
      }
    }, */
    /*     async startBackgroundTask() {
      const taskId = BackgroundRunner.beforeExit(async () => {
        await this.checkConditionAndNotify();
        BackgroundRunner.finish({ taskId });
      });
    },
    async checkConditionAndNotify() {
      // Příklad asynchronního načítání dat

    // Generování náhodného čísla mezi 0 a 99
      // let randomNumber = Math.floor(Math.random() * 100);

      const data = await this.fetchData();
      const condition = this.evaluateCondition(data);

      if (condition) {
        await LocalNotifications.schedule({
          notifications: [
            {
              title: "Condition Met",
              body: "The condition for generating a notification has been met.",
              id: 1,
              schedule: { at: new Date(Date.now() + 1000 * 5) }, // optional
              sound: null,
              attachments: null,
              actionTypeId: "",
              extra: null,
            },
          ],
        });
      }
    },
    async fetchData() {
      // Nahraďte skutečným API voláním
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ value: Math.random() });
        }, 2000);
      });
    },

    evaluateCondition(data) {
      // Jednoduchá podmínka pro příklad
      return data.value > 0.5;
    },

    async scheduleNotification() {
      await LocalNotifications.requestPermissions();
      await LocalNotifications.schedule({
        notifications: [
          {
            title: "Test Notification",
            body: "This is a test notification",
            id: 1,
            schedule: { at: new Date(Date.now() + 1000 * 5) }, // 5 seconds from now
            sound: null,
            attachments: null,
            actionTypeId: "",
            extra: null,
          },
        ],
      });
    }, */
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped></style>
